@import '../../style/globals.scss';

.AriseDebugMenu {
    height: auto;
    padding: 0px;
    font-size: 14px;

    .errorMessage {
        color: #ff6b6b;
    }

    ul {
        width: 100%;
        padding: 0;
        margin: 0;
        list-style: none;

        li {
            overflow: auto;
            padding: 8px 12px;
            background-color: rgba(0, 0, 0, 0.15);

            &:nth-child(odd) {
                background-color: rgba(255, 255, 255, 0.05);
            }
        }
    }

    section {
        padding: 8px;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        margin: 4px;

        h3 {
            margin-bottom: 8px;
            font-size: 16px;
            font-weight: bold;
        }

        button {
            padding: 12px 16px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            margin: 4px;
            background-color: #333;
            color: #fff;
            border-radius: 4px;
            cursor: pointer;
            transition: all 150ms ease;

            &:hover {
                background-color: #555;
                transform: translateY(-1px);
            }

            &:active {
                transform: translateY(0);
            }
        }
    }

    .formGroup {
        margin: 12px 4px;

        label {
            display: block;
            margin-bottom: 4px;
            font-size: 13px;
            color: rgba(255, 255, 255, 0.8);
        }

        input,
        textarea {
            width: 100%;
            padding: 8px 12px;
            background-color: rgba(0, 0, 0, 0.3);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 4px;
            color: #fff;
            font-size: 14px;
            font-family: inherit;
            box-sizing: border-box;

            &::placeholder {
                color: rgba(255, 255, 255, 0.4);
            }

            &:focus {
                outline: none;
                border-color: rgba(255, 255, 255, 0.4);
                background-color: rgba(0, 0, 0, 0.4);
            }
        }

        textarea {
            resize: vertical;
            min-height: 60px;
        }
    }
}
